/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'
import { APIReportPHP, APICore } from '@/utils/servicesApi'
const qs = require('qs')


export function getDetailEditByScheduleId(id) {
    return requestDev({
        url: APIReportPHP() + '/instagram/schedule/get_detail_edit?id=' + id,
        method: 'GET',
    })
}
export function listLogs(params) {
    return requestDev({
        url: APIReportPHP() + '/instagram/schedule/logs/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function summaryLogs(params) {
    return requestDev({
        url: APIReportPHP() + '/instagram/schedule/logs/summary',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function schedulePreparing(data) {
    return requestRaw({
        url: APICore() + '/instagram/schedule/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function getMediaTypeList() {
    return requestRaw({
        url: APICore() + '/instagram/schedule/media_type_list',
        method: 'GET',
    })
}
export function getMediaTypeListS() {
    return requestRaw({
        url: APICore() + '/instagram/schedule/media_type_list_official',
        method: 'GET',
    })
}
export function listSchedule(params) {
    return requestDev({
        url: APIReportPHP() + '/instagram/schedule/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function actionStore(data) {
    return requestRaw({
        url: APICore() + '/instagram/schedule/action_stored',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function getDetailLog(params) {
    return requestDev({
        url: APIReportPHP() + '/instagram/schedule/get_detail_log',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// export function scrapingActionStored(data) {
//     return requestRaw({
//         url: APICore() + '/scraping/action_stored',
//         method: 'POST',
//         data: data // untuk array data post
//     })
// }
// export function getMarketplaceByScheduleId(id) {
//     return requestDev({
//         url: APIReportPHP() + '/scraping/schedule/get_marketplace?id=' + id,
//         method: 'GET',
//     })
// }
// export function getKeywordsByScheduleId(id) {
//     return requestDev({
//         url: APIReportPHP() + '/scraping/schedule/get_keywords?id=' + id,
//         method: 'GET',
//     })
// }


// export function retryScrapingRawDetail(data) {
//     return requestRaw({
//         url: APICore() + '/scraping/retry_scraping_raw_detail',
//         method: 'POST',
//         data: data // untuk array data post
//     })
// }

// export function scrapingDetailProduct(data) {
//     return requestRaw({
//         url: APICore() + '/scraping/detail_item_product',
//         method: 'POST',
//         data: data // untuk array data post
//     })
// }


// export function detailKeywords(id) {
//     return requestRaw({
//         url: APICore() + '/keywords/detail?id=' + id,
//         method: 'GET',
//     })
// }
// export function addKeywords(data) {
//     return requestRaw({
//         url: APICore() + '/keywords/create',
//         method: 'POST',
//         data: data // untuk array data post
//     })
// }

// export function listKeywords(data) {
//     return requestRaw({
//         url: APICore() + '/keywords/list-data',
//         method: 'POST',
//         data: data // untuk array data post
//     })
// }

// export function getMonitoringSortByList() {
//     return requestRaw({
//         url: APICore() + '/public/static/monitoring_sortby_list',
//         method: 'GET',
//     })
// }

// export function getMonitoringListStatus() {
//     return requestRaw({
//         url: APICore() + '/public/static/monitoring_status_list',
//         method: 'GET',
//     })
// }


// export function listLinkExcel(params) {
//     return requestDev({
//         url: APIReportPHP() + '/monitoring/list_excel',
//         method: 'POST',
//         data: qs.stringify(params)
//     })
// }

// export function listLink(params) {
//     return requestDev({
//         url: APIReportPHP() + '/monitoring/list',
//         method: 'POST',
//         data: qs.stringify(params)
//     })
// }

// export function listLog(params) {
//     return requestDev({
//         url: APIReportPHP() + '/scraping/log/list',
//         method: 'POST',
//         data: qs.stringify(params)
//     })
// }


// WEBPACK FOOTER //
// ./src/api/instagramSchedule.js